export default "__VITE_ASSET__2ba7fc2a__"